<template>
  <div class="a5-page a5-container">
    <!-- Hero Section -->
    <section class="page-content">
      <div class="title-box">
        <p style="font-size: 3vw;font-weight: 600;">ANOVATOR A5</p>
        <p style="font-size: 1vw;">Comprehensive body composition analyzer</p>
      </div>
      <div class="features-box">
        <img class="feature-img" src="/static/images/product/a5-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-main2x.png" alt="" />
      </div>
      <div class="scroll-mouse" style="bottom: -6%;" v-show="showScrollMouse">
          <img style="width: 30px;height: 30px;" src="/static/images/mouse-w.png"/>
          <p style="color: #FFFFFF;font-size: 12px;margin-top: 10px;">Scroll Mouse</p>
        </div>
    </section>

    <!-- Perfect Body Section -->
    <section class="page-content">
      <div class="features-box">
        <img class="feature-img" src="/static/images/product/a5-main.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-module1-2x.png" alt="" />
      </div>
      <div class="title-box">
        <p class="text_10 bold-text">Perfect body</p>
        <p style="padding: 0 20px;font-size: 15px;font-family: MiSans-Regular;">A5 supports 12 functions, comprehensive detection of body risk, professional<br> version of body composition detection instrument</p>
      </div>
      <div class="function-box">
        <div v-for="func in functions" :key="func">{{ func }}</div>
      </div>
    </section>

    <!-- HD Screen Section -->
    <section class="page-content">
      <div class="left-title-box">
        <span class="large-number">32</span><span class="unit">&nbsp; INCH</span><br />
        <p class="feature-title bold-text">HD SCREEN</p>
        <p class="feature-desc">Immersive body testing <br>IPS HD Touch</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-jishen.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-jishenx2.png" alt="" />
      </div>
    </section>

    <!-- Black Tempered Glass Section -->
    <section class="page-content">
      <div class="rightB-title-box">
        <p class="feature-title bold-text">Black <br>tempered glass</p>
        <p class="feature-desc">Highlight the beauty of industrial technology, minimalist high-end fashion</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-dizuo.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-dizuox2.png" alt="" />
      </div>
    </section>

    <!-- AI Camera Section -->
    <section class="page-content">
      <div class="left-title-box">
        <span class="large-number">AI</span><br />
        <p class="feature-title bold-text" style="text-align: left;">SMART VISUAL<br> CAMERA <br>1080P</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-camera.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-camera2x.png" alt="" />
      </div>
    </section>

    <!-- Ultrasonic Sensor Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="rightB-title-box">
        <p class="text_10 bold-text" style="text-align: left;padding-left: 20px;">Ultrasonic <br> sensor</p>
        <table class="param-box">
          <tr>
            <td>50K Hz</td>
            <td>5mm</td>
          </tr>
          <tr>
            <td>Center frequency</td>
            <td>Measurement accuracy</td>
          </tr>
        </table>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-dingpeng.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-dingpengx2.png" alt="" />
      </div>
    </section>

    <!-- Horizontal Wave Sensor Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="features-box">
        <img class="feature-img" src="/static/images/product/a5-spbdcgq.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-spbdcgq2x.png" alt="" />
      </div>
      <div class="overlap-box">
        <img class="overlap-img" src="/static/images/product/curve.png" alt="Curve" />
      </div>
      <div class="title-box">
        <p class="text_10 bold-text">Horizontal wave sensor</p>
      </div>
    </section>

    <!-- Balance Assessment Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="right-title-box txt-adjust">
        <span class="text_24 bold-text">Balance <br>Assessment</span>
        <p class="balance-desc" style="margin-top: 20px;">A high-precision horizontal Angle sensor is used to measure the shaking <br>amplitude of the human body and evaluate the strength of the balance <br>ability. This evaluation directly reflects the muscle development and control <br>status, and provides scientific data support for subsequent training.</p>
      </div>
      <div class="features-box">
        <img style="width: 80vw;margin: 0 auto;" class="feature-img mobile-adjust txt-adjust balance-img" src="/static/images/product/a5-sgcs.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-sgcsx2.png" alt="" />
      </div>
    </section>

    <!-- Physical Risk Assessment Section -->
    <section class="page-content" style="margin-top: 10px;">
      <div class="left-title-box" style="bottom: 35%;margin-top: 50px;">
        <span class="text_10 bold-text">Physical <br>risk assessment</span>
        <br><br>
        <div class="tzt-item" v-for="risk in riskItems" :key="risk">{{ risk }}</div>
      </div>
      <div class="features-box">
        <img class="feature-img tzt-img" src="/static/images/product/a5-tzt.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-tztx2.png" alt="" />
      </div>
    </section>

    <!-- Healthy Companion Section -->
    <section class="page-content">
      <div class="title-box txt-will">
        <span class="bold-text">A5 will be <br> your healthy companion</span>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/a5-will.png" data-src="https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/a5-willx2.png" alt="" />
      </div>
    </section>

    <!-- Medical Grade Section -->
    <div class="container medical-section">
      <div class="pj-box">
        <span class="text_24 bold-text">Medical grade</span>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <img src="/static/images/product/a5-xy.png" alt="Blood Oxygen" />
          <div class="img-desc">
            <p class="desc-title bold-text">Blood oxygen</p>
            <p class="desc-text">
              One minute resting heart rate and blood oxygen concentration were measured to assess the strength of cardiopulmonary function, 
              providing accurate data support for daily training intensity planning.
            </p>
          </div>
        </div>
        <div class="col-lg-6">
          <img src="/static/images/product/a5-xya.png" alt="Blood Pressure" />
          <div class="img-desc">
            <p class="desc-title bold-text">Blood pressure measurement</p>
            <p class="desc-text">
              Medical-grade blood pressure measurement to monitor exercise risk. Eliminate high blood pressure, 
              women's menstrual exercise risk, make exercise more comfortable.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Technical Specifications Section -->
    <div style="background-color: #000000;padding-bottom: 10px;">
      <div class="container">
        <div class="tb-title">
          TECHNICAL SPECIFICATIONS:
        </div>
        
        <table class="tb technical-tb">
          <tr v-for="(row, index) in technicalSpecs" :key="index">
            <template v-if="row[1] === ''">
              <td class="tb-key" colspan="2">{{ row[0] }}</td>
            </template>
            <template v-else>
              <td class="tb-key">{{ row[0] }}</td>
              <td class="tb-key">{{ row[1] }}</td>
            </template>
          </tr>
        </table>
        
        <h4 style="margin-top: 50px;margin-bottom: 20px;color: #FFFFFF;">A5 Body Composition Analyzer</h4>
        <table class="tb product-parameters">
          <tr v-for="(param, index) in productParameters" :key="index">
            <td class="tb-col1" v-if="param.rowspan" :rowspan="param.rowspan">{{ param.category }}</td>
            <td class="tb-col2">{{ param.label }}</td>
            <td class="tb-col3" v-html="param.value"></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- 3D Product View Section -->
    <div class="product-3d-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h2 class="section-title text-center" style="text-transform: uppercase;">A5 3D Product View</h2>
            <div class="iframe-container">
              <iframe 
                src="/static/web/a5/a5.html" 
                width="100%" 
                height="700px" 
                frameborder="0"
                class="product-iframe"
              ></iframe>
              <p class="iframe-desc">Drag to rotate • Double-click for fullscreen</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lazyLoadingMixin } from '@/mixins/lazyLoading'

export default {
  name: 'A5',
  mixins: [lazyLoadingMixin],
  data() {
    return {
      showScrollMouse: true,
      functions: [
        'Body composition analysis',
        'Athletic capacity Analysis',
        'Sp02',
        'Sports safety Analysis',
        'Balance Assessment',
        'Heart Rate Test',
        'Response Assessment',
        'Body posture Analysis',
        'Detection Data Analysis',
        'Visual acuity Assessment',
        'Shoulder Joint Range of motion Evaluation Function',
        'Test Report'
      ],
      riskItems: [
        'High and low shoulders',
        'X/O legs',
        'Hunchback',
        'Pelvis tilted forward'
      ],
      technicalSpecs: [
        ['User ID Login/Phone Number Login', 'On Screen Results'],
        ['Printable Results', 'Handle Grips'],
        ['Height', 'Weight'],
        ['BMI', 'Body Fat Percentage'],
        ['Muscle Mass', 'Visceral Fat Area'],
        ['Subcutaneous Fat Area', 'Protein Content'],
        ['Total Body Water', 'Skeletal Muscle'],
        ['BMR(kcal)', 'Obesity Degree (%)'],
        ['Desirable Weight', 'Weight Control'],
        ['Fat Control', 'Muscle Control'],
        ['Segmental Muscle', 'Segmental Body Fat'],
        ['Body Type Classification', 'Balance Test'],
        ['lung Capacity Test', 'Fat-Free Body'],
        ['Bone Mass', 'WHR'],
        ['Body Age', 'SpO2 %'],
        ['Blood Pressure Test', 'Exercise Intensity'],
        ['Vision Test', 'Body Posture Analysis'],
        ['Total Energy Expenditure (kcal)', 'Calorie Consumption (kcal/hour)'],
        ['Expected Fat Burning (kg)', 'Target Body Fat'],
        ['Exercise Program Advice', 'Estimated Completion Period'],
        ['Body Composition History', 'Pervious Data Comparison'],
        ['Responsiveness Test', '']
      ],
      productParameters: [
        { category: 'Screen Host', label: 'Brand', value: 'Anovator', rowspan: 7 },
        { label: 'Product Name', value: 'Body Composition Analyzer' },
        { label: 'Model', value: 'A5' },
        { label: 'Color', value: 'Black' },
        { label: 'Operating System', value: 'Android 7.1' },
        { label: 'Camera', value: '1080P' },
        { label: 'Material', value: 'Tempered Glass Led Screen + Aluminum Alloy' },
        { category: 'Size & Weight', label: 'Product Size', value: 'Host: 1700mm*460mm<br />Base: 108mm*480mm*900mm<br />Bracket: 200*451mm*600', rowspan: 3 },
        { label: 'Package Size', value: 'Host: 1810mm*220mm*610mm<br />Base: 1010mm*577mm*180mm<br />Bracket: 570mm*437mm*525mm' },
        { label: 'Weight', value: '67KG' },
        { category: 'Display Screen', label: 'Screen Size', value: '32 Inch', rowspan: 2 },
        { label: 'Screen Type', value: '1080*1920 IPS HD Touch' },
        { category: 'Technical Parameters', label: 'Measurement methods', value: '8-point contact electrodes, multi-frequency bioelectrical impedance analysis technology', rowspan: 6 },
        { label: 'Frequency', value: '20,100 kHz' },
        { label: 'Electric Current', value: '<280uA' },
        { label: 'Power consumption', value: '60W' },
        { label: 'Height Measurement', value: 'High Frequency Ultrasonic Sensing' },
        { label: 'Spirometry', value: 'High Precision Air Pressure Sensor' },
        { category: 'Function parameter', label: 'Report', value: 'Phone/Paper Print Report/Web', rowspan: 8 },
        { label: 'Voltage', value: 'Input: AC 220V，50/60Hz <br />Output：DC 12V,7A' },
        { label: 'Transmission Port', value: 'USB2.0/Bluetooth/Wired/Wireless' },
        { label: 'Height Range', value: '80-200cm' },
        { label: 'Weight Range', value: '0-200kg' },
        { label: 'Age Range', value: '3-99 years old' },
        { label: 'Operating Environment', value: 'Internet Connection Required <br />Temperature: 10-40℃, Humidity: 30%-75% <br />Do not place the device by the window to avoid direct sunlight.<br />Do not shine direct light on the device screen.' },
        { label: 'Warranty', value: '2 Years' }
      ]
    }
  },
  mounted() {
    document.title = 'A5 - Anovator';
    this.handleScrollMouseVisibility();
    window.addEventListener('scroll', this.handleScrollMouseVisibility);
    
    // 20秒后自动隐藏
    setTimeout(() => {
      this.showScrollMouse = false;
    }, 20000);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScrollMouseVisibility);
  },
  methods: {
    handleScrollMouseVisibility() {
      if (window.scrollY > 100) {
        this.showScrollMouse = false;
      }
    }
  }
}
</script>

<style scoped>

.a5-page {
  background-color: #000000;
}

.page-content {
  position: relative;
  width: 100vw;
  height: 100%;
}

.features-box {
  width: 100%;
  height: 100%;
}

.feature-img {
  display: block;
  width: 100vw;
  height: calc(100vh - 90px);
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
}

.title-box {
  position: absolute;
  width: 100%;
  top: 140px;
  text-align: center;
  z-index: 10;
  color: #FFFFFF;
}

.scroll-mouse {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.function-box {
  position: relative;
  bottom: 8vw;
  width: 80%;
  margin: 0 auto;
}

.function-box div {
  display: inline-block;
  font-size: 15px;
  border-radius: 25px;
  padding: 12px 20px;
  background-color: rgba(26, 26, 26, 1);
  margin-right: 20px;
  margin-top: 10px;
  color: #FFFFFF;
}

.text_10 {
  background-image: linear-gradient(
    360deg,
    rgba(192, 214, 255, 1) 0,
    rgba(238, 242, 255, 1) 100%
  );
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bold-text {
  font-weight: 600;
  font-size: 45px !important;
  line-height: 55px !important;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  color: #FFFFFF;
}

.text_24 {
  background-image: linear-gradient(
    225deg,
    rgba(50, 197, 255, 1) 0,
    rgba(182, 32, 224, 1) 51.258389%,
    rgba(247, 181, 0, 1) 100%
  );
  width: 122px;
  height: 127px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 96px;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 127px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.left-title-box {
  position: absolute;
  left: 20%;
  bottom: 45%;
  z-index: 10;
}

.right-title-box {
  position: absolute;
  right: 25%;
  top: 30%;
  z-index: 10;
}

.rightB-title-box {
  position: absolute;
  right: 10%;
  bottom: 15%;
  z-index: 10;
}

.overlap-box {
  position: absolute;
  text-align: center;
  width: 100%;
  top: 25%;
  z-index: 10;
}

.overlap-img {
  width: 38vw;
}

.param-box {
  width: 130%;
  color: #FFFFFF;
  border: none;
}

.param-box td {
  border: none;
}

.param-box tr:first-child {
  font-size: 28px;
  font-weight: 600;
}

.tzt-item {
  display: inline-block;
  padding: 10px 20px;
  color: #FFFFFF;
  text-align: center;
  border: 1px solid #979797;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.balance-desc {
  font-family: MiSans-Bold;
  font-size: 18px;
  margin-bottom: 10px;
  color: #FFFFFF;
}

.txt-will {
  top: 35vh;
  text-align: center;
  padding: 20px;
  color: #FFFFFF;
}

.txt-will span {
  color: #FFFFFF;
  font-weight: 100;
}

.pj-box {
  position: relative;
  width: 100%;
  height: 300px;
  text-align: center;
  padding: 150px 0;
  color: #FFFFFF;
}

.img-desc {
  padding-top: 20px;
  color: #FFFFFF;
}

.img-desc p {
  color: #FFFFFF;
}

.tb-title {
  width: 100%;
  height: 300px;
  padding-top: 230px;
  font-size: 30px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 35px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 50px;
  color: #FFFFFF;
}

.tb th, .tb td {
  border: 1px solid #3F3F3F;
  padding: 15px;
}

.tb tr {
  height: 40px;
}

.tb-key {
  width: 50%;
  background-image: url('../../../public/static/images/checkmark.png');
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-y: 50%;
  background-position-x: 97%;
  padding-right: 30px;
}

.tb-col1 {
  width: 20%;
  font-weight: 600;
  text-align: center;
}

.tb-col2 {
  width: 30%;
  text-align: left;
}

.tb-col3 {
  width: 50%;
  text-align: left;
}

.product-3d-section {
  background-color: #f8f9fa;
  padding: 60px 0;
  margin-top: 60px;
}

.iframe-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  padding: 20px;
  margin: 0 auto;
}


.a5-container {
  background-color: #000000;
  min-height: 100vh;
}

/* Global text color for black background */
p, span, div, td, th {
  color: #FFFFFF;
}


h1, h2, h3, h4, h5, h6, .title, .heading {
  font-family: 'MiSans-Bold', sans-serif;
}

.text_25 {
  font-size: 25px;
  font-family: MiSans-Bold;
  font-weight: 700;
  color: #FFFFFF;
}

.balance-desc {
  font-family: 'MiSans-Regular', sans-serif;
  font-size: 16px;
  line-height: 1.6;
}

.img-desc {
  font-family: 'MiSans-Regular', sans-serif;
}

.tb, .tb th, .tb td {
  font-family: 'MiSans-Regular', sans-serif;
}

.product-iframe {
  border: none;
  border-radius: 10px;
  min-height: 300px;
}

.iframe-desc {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}
.large-number{
    background-image: linear-gradient(225deg, rgba(50, 197, 255, 1) 0, rgba(182, 32, 224, 1) 51.258389%, rgba(247, 181, 0, 1) 100%);
    width: 122px;
    height: 127px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 96px;
    text-transform: uppercase;
    font-family: MiSans-Bold;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    line-height: 127px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.feature-title{
    background-image: linear-gradient(360deg, rgba(192, 214, 255, 1) 0, rgba(238, 242, 255, 1) 100%);
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    text-transform: uppercase;
    font-family: MiSans-Bold;
    font-weight: 700;
    text-align: center;
    white-space: nowrap;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}


@media (max-width: 768px) {
  .txt-adjust {
    text-align: center !important;
  }
  
  .txt-will {
    top: 20vh !important;
  }
  
  .bold-text {
    font-size: 30px !important;
    line-height: 35px !important;
  }
  
  .param-box {
    width: 100% !important;
  }
  
  .balance-desc {
    font-size: 14px !important;
    padding: 0 20px;
  }
  
  .left-title-box, .right-title-box, .rightB-title-box {
    position: relative !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    top: auto !important;
    text-align: center !important;
    padding: 20px;
  }
  
  .function-box {
    width: 95% !important;
    bottom: 5vw !important;
  }
  
  .function-box div {
    font-size: 13px !important;
    padding: 8px 15px !important;
    margin-right: 10px !important;
  }
  
  .overlap-img {
    width: 60vw !important;
  }
  
  .tb-title {
    height: 200px !important;
    padding-top: 150px !important;
    font-size: 24px !important;
  }
  
  /* 优化技术规格表格在移动端的显示 */
  .container {
    padding: 0 10px !important;
  }
  
  .tb {
    font-size: 11px !important;
    margin: 10px 0 !important;
  }
  
  .tb th, .tb td {
    padding: 8px 5px !important;
    font-size: 11px !important;
    line-height: 1.3 !important;
    word-wrap: break-word !important;
  }
  
  .tb-key {
    background-size: 16px !important;
    background-position-x: 95% !important;
    padding-right: 20px !important;
  }
  
  .tb-col1 {
    width: 25% !important;
    font-size: 10px !important;
  }
  
  .tb-col2 {
    width: 35% !important;
    font-size: 10px !important;
  }
  
  .tb-col3 {
    width: 40% !important;
    font-size: 10px !important;
  }
  
  /* 页面内容区域移动端优化 */
  .page-content {
    flex-direction: column !important;
    padding: 40px 15px !important;
    min-height: auto !important;
  }
  
  .features-box {
    margin: 20px 0 !important;
    order: 2;
  }
  
  .large-number {
    font-size: 60px !important;
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
  
  .unit {
    font-size: 16px !important;
  }
  
  .feature-title {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  
  .feature-desc {
    font-size: 14px !important;
    line-height: 1.4 !important;
  }
  
  /* 3D产品展示区域移动端优化 */
  .product-3d-section {
    padding: 40px 0 !important;
    margin-top: 40px !important;
  }
  
  .iframe-container {
    padding: 15px !important;
    margin: 0 10px !important;
  }
  
  .product-iframe {
    height: 400px !important;
    min-height: 300px !important;
  }
  
  .section-title {
    font-size: 20px !important;
    margin-bottom: 20px !important;
  }
  
  .pj-box {
    height: 200px !important;
    padding: 100px 0 !important;
  }
  
  .img-desc {
    padding: 10px !important;
  }
  
  .img-desc p {
    font-size: 14px !important;
  }
  .mobile-adjust{
    height: auto;
  }
  .tzt-img{
    height: 30vh;
  }
}
.iframe-desc{
  color: #4d4d4d;
}

/* 4K and large screen optimization */
@media (min-width: 1920px) {
  .feature-img, .feature-img2 {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .features-box {
    width: 100vw !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .overlap-img {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
}
</style>